import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ClientVerificationPanel = ({ clientData, onVerify, onCancel }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Kundeninformationen überprüfen</h3>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-warning/10 text-warning rounded-md text-sm font-medium">
          <Icon name="AlertTriangle" size={16} />
          <span>Überprüfung erforderlich</span>
        </div>
      </div>
      <div className="space-y-6">
        {/* Client Photo */}
        <div className="flex items-center gap-4 pb-6 border-b border-border">
          <div className="relative">
            <Image
              src={clientData?.photo}
              alt={clientData?.photoAlt}
              className="w-24 h-24 rounded-lg object-cover border-2 border-border"
            />
            <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-success rounded-full flex items-center justify-center border-2 border-card">
              <Icon name="Check" size={16} color="white" />
            </div>
          </div>
          <div>
            <h4 className="text-xl font-semibold text-foreground">{clientData?.fullName}</h4>
            <p className="text-sm text-muted-foreground mt-1">Kundennummer: {clientData?.clientNumber}</p>
          </div>
        </div>

        {/* Personal Information */}
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Vorname</label>
            <p className="text-sm font-medium text-foreground mt-1">{clientData?.firstName}</p>
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Nachname</label>
            <p className="text-sm font-medium text-foreground mt-1">{clientData?.lastName}</p>
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Geburtsdatum</label>
            <p className="text-sm font-medium text-foreground mt-1">{clientData?.dateOfBirth}</p>
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Geburtsort</label>
            <p className="text-sm font-medium text-foreground mt-1">{clientData?.placeOfBirth}</p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="pt-4 border-t border-border">
          <h4 className="text-sm font-semibold text-foreground mb-4">Kontaktinformationen</h4>
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Adresse</label>
              <p className="text-sm font-medium text-foreground mt-1">{clientData?.address}</p>
            </div>
            <div>
              <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Telefonnummer</label>
              <p className="text-sm font-medium text-foreground mt-1">{clientData?.phone}</p>
            </div>
            <div>
              <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">E-Mail</label>
              <p className="text-sm font-medium text-foreground mt-1">{clientData?.email}</p>
            </div>
            <div>
              <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Beruf</label>
              <p className="text-sm font-medium text-foreground mt-1">{clientData?.occupation}</p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-3 pt-6 border-t border-border">
          <button
            onClick={onVerify}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-success text-white rounded-md hover:bg-success/90 transition-colors font-medium"
          >
            <Icon name="CheckCircle" size={20} />
            <span>Daten bestätigen</span>
          </button>
          <button
            onClick={onCancel}
            className="px-4 py-3 border border-border rounded-md hover:bg-muted transition-colors text-foreground font-medium"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientVerificationPanel;